var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDC80B",
    stroke: "#fff",
    strokeWidth: 4,
    d: "M16.749 4.764c1.197-3.685 6.411-3.685 7.608 0l2.536 7.802h8.203c3.875 0 5.486 4.959 2.351 7.236l-6.637 4.823 2.536 7.802c1.197 3.685-3.02 6.75-6.156 4.472l-6.637-4.822-6.637 4.822c-3.135 2.277-7.352-.787-6.155-4.472l2.535-7.802-6.638-4.823c-3.134-2.277-1.523-7.236 2.352-7.236h8.204z"
  })));
};
export default SvgStar;